export enum eApplicationActions {
  OpenEditSingleFieldAction = 'Application Action - Open Edit Single Field Action',
  CloseEditSingleFieldAction = 'Application Action - Close Edit Single Field Action',
  SetOrder = 'Application Action - Set Order',
  SetError = 'Application Action - Set Error',
}
